import { extractAxiosErrorMessage } from "@inrange/building-manager-api-client";
import { useEffect } from "react";
import { UseMutationResult } from "@tanstack/react-query";

/** Handles async error extraction for any React Query query/mutation */
export function useReactQueryError(
  rq: UseMutationResult<any, any, any, any>,
  prefix: string = "Error"
) {
  useEffect(() => {
    if (!rq.isError) return;

    (async () => {
      const msg = await extractAxiosErrorMessage(rq.error);
      alert(`${prefix} - ${msg}`);
      rq.reset?.();
    })();
  }, [rq.isError, rq.error, rq, prefix]);
}
